import { useCallback, useMemo } from 'react';
import { Roles } from 'configs/roles';
import {
  useGetAdminActionsQuery,
  useGetUserProfileQuery,
} from 'services/user/queries';
import {
  checkRolesIncludeRoles,
  checkValidActionRoleAdmin,
} from 'utils/helpers/auth';

const MANAGEMENT_ROLES = [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.MC];

export const useManagementAccess = () => {
  const { data: profile, isError: isProfileError } = useGetUserProfileQuery();
  const { data: permissions, isError: isPermissionsError } =
    useGetAdminActionsQuery();
  const roles = useMemo(
    () => (profile?.role && !isProfileError ? [profile.role as Roles] : []),
    [profile?.role, isProfileError],
  );

  return useCallback(
    (action: string | string[]) =>
      checkRolesIncludeRoles(roles, MANAGEMENT_ROLES) &&
      checkValidActionRoleAdmin(action, {
        roles,
        adminActions: isPermissionsError ? [] : permissions?.adminActions || [],
      }),
    [roles, permissions?.adminActions, isPermissionsError],
  );
};
